import { useQuery as useRetailerQuery } from "@faire/web-api--source/api/retailer/retailerToken/get-hooks";

import { getRetailer } from "@faire/retailer/serialized-data/getRetailer";

export const useRetailer = () => {
  const serializedRetailer = getRetailer();

  const { data: retailer, refetch: refetchRetailer } = useRetailerQuery(
    serializedRetailer?.token ?? "",
    undefined,
    {
      enabled: !!serializedRetailer?.token,
      initialData: serializedRetailer,
      refetchOnMount: false,
    }
  );
  const retailerName = retailer?.name;
  const retailerToken = retailer?.token;

  const faireCredit = (retailer && retailer.available_balance_cents) || 0;

  const currency = retailer?.currency;
  const showR2B = !!retailer && !retailer.hide_retailer2_maker;

  return {
    retailer,
    retailerToken,
    refetchRetailer,
    retailerName,
    faireCredit,
    currency,
    showR2B,
  };
};
